import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthenticationModule } from './core/authentication/authentication.module';

import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
// EnvironmentVariableService is a singleton so it's provided at the root Angular modules
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { provideModalService, provideToastService, ToastComponent } from '@msi/cobalt-prime';
import { IamAuthGrantConfigToken, UserAuthenticationModule } from '@msi/commandcentral-common-header';
import { appConfig, getAppSpecificIamConfig } from './config/app.config';
import { FailedAuthenticatedPageComponent } from './core/authentication/failed-authenticated-page/failed-authenticated-page.component';
import { ConfirmAuthGuardService } from './core/authentication/services/confirm-authentication-guard';
import { SuccessInterceptorService } from './modules/common/http-interceptors/success-interceptor.service';

const routes: Routes = [
  { path: 'unauthorized', component: FailedAuthenticatedPageComponent },
  {
    path: 'provisioning',
    loadChildren: () => import('./modules/location-provisioning/location-provisioning.module').then((m) => m.LocationProvisioningModule),
    canLoad: [ConfirmAuthGuardService],
    canActivate: [ConfirmAuthGuardService],
  },
  { path: '', redirectTo: 'provisioning', pathMatch: 'full' },
  { path: 'adminuiv2', redirectTo: 'provisioning', pathMatch: 'full' },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    ToastComponent,
    BrowserAnimationsModule,
    AuthenticationModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return sessionStorage.getItem('token');
        },
      },
    }),
    RouterModule.forRoot(routes),
    UserAuthenticationModule,
  ],
  providers: [
    JwtHelperService,
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptorService, multi: true },
    { provide: IamAuthGrantConfigToken, useFactory: getAppSpecificIamConfig },
    ...appConfig.providers,
    provideToastService(),
    provideModalService(),
  ],
  bootstrap: [AppComponent],
  exports: [RouterModule],
})
export class AppModule {}
